import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
    AnnualReportProvider,
    IOptions,
    ISectionData,
    PDFSectionIds,
    PrintUsingPdfTronDto,
} from '@modeso/aumico-lib-annualreport-fe';
import { EditSectionTitleComponent } from '@modeso/aumico-lib-core-fe';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, map, tap } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'annual-report-account-proof-swiss-print-preview',
    templateUrl: './account-proof-swiss-print-preview.page.html',
    styleUrls: ['./account-proof-swiss-print-preview.page.scss'],
})
export class AccountProofSwissPrintPreviewPage implements OnInit {
    @Input()
    public reportType: string;
    @Input() noPreviousData: boolean;
    @Input() printOptions: IPrintOptions;
    @Input() textColor: string;
    public pdfTronOptions: IOptions;

    @Output() sectionTitleChanged: EventEmitter<string> = new EventEmitter<string>();

    public sectionData: ISectionData;
    public sectionTitle: string | undefined;

    constructor(
        private readonly annualReportProvider: AnnualReportProvider,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private dialog: MatDialog,
    ) {
        this.addSvgIcon('aumico-pattern-icon-edit-write');
    }

    ngOnInit(): void {
        this.annualReportProvider
            .getPrintView$()
            .pipe(
                filter((printViewData: PrintUsingPdfTronDto) => printViewData != null),
                tap((printViewData: PrintUsingPdfTronDto) => (this.pdfTronOptions = printViewData.data.options)),
                map((printViewData: PrintUsingPdfTronDto) => printViewData.data.sections),
                map((sections: ISectionData[]) =>
                    sections.find(
                        (section) =>
                            section.sectionId ===
                            (this.reportType === 'income' ? PDFSectionIds.APIS : PDFSectionIds.APBS),
                    ),
                ),
                untilDestroyed(this),
            )
            .subscribe((items) => {
                this.sectionData = items;
                this.sectionTitle = items?.title;
            });
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    public editSectionTitle(): void {
        const dialogRef = this.dialog.open<EditSectionTitleComponent, string, string | undefined>(
            EditSectionTitleComponent,
            {
                disableClose: false,
                panelClass: 'custom-modalbox',
                data: this.sectionTitle,
            },
        );

        dialogRef
            .afterClosed()
            .pipe(untilDestroyed(this))
            .subscribe((result) => {
                if (result != null) {
                    this.sectionTitle = result;
                    this.sectionTitleChanged.emit(result);
                }
            });
    }
}
